import { render, staticRenderFns } from "./examInitiateList.vue?vue&type=template&id=10504134&scoped=true&"
import script from "./examInitiateList.vue?vue&type=script&lang=js&"
export * from "./examInitiateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10504134",
  null
  
)

export default component.exports